module.exports = __webpack_public_path__ + "static/media/r-md18.30a6038e.png";